import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
//import './Aa4HomePageStyle.css';

function Aa4HomePage() {

  const otpContainerRef = useRef([]);
  const [language, setLanguage] = useState('AR');
  const [msisdn, setMsisdn] = useState(null);
  const [warning, setWarning] = useState(false);
  const [otp, setOtp] = useState([null, null, null, null, null, null]);
  const [isGradient, setIsGradient] = useState(false);
  
  useEffect(() => {
    const handleClickOutside = (event) => 
    {
      if (otpContainerRef.current && !otpContainerRef.current.contains(event.target)) 
      {
        closeOtp();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(224,112,197,0.4) 50%, rgba(98,111,242,1) 50%)'
      : 'linear-gradient(to left, rgba(224,112,197,0.4) 50%, rgba(98,111,242,1) 50%)',
  };

  const handleMsisdnChange = (event) => {
    const newMsisdn = event.target.value;
    setMsisdn(newMsisdn);
    setWarning(false);
  }

  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    if (index < otp.length - 1 && value !== '') {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
    setOtp(newOtp);
  };

  const handleSubscribeClick = () => {
    if(!isMsisdnValid())
    {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح';
      setWarning(true);
      return;
    }

    setWarning(false);
    document.getElementById('myOtp').style.display = 'block';
    document.getElementById('otp-input-0').focus();
  }

  const isMsisdnValid = () => {
    if(msisdn !== null && msisdn !== undefined)
    {
      return ( (msisdn.length === 10 && msisdn.startsWith('05')) || (msisdn.length === 9 && msisdn.startsWith('5')) );
    }
    return false;
  }

  const closeOtp = () => {
    document.getElementById('myOtp').style.display = 'none';
    clearOtpInput();
  };

  const clearOtpInput = () => {
    const otpElements = document.querySelectorAll('[id^="otp-input-"]');
      otpElements.forEach((element) => {
        element.value = '';
        element.style.border = '';
    });
    setOtp([null, null, null, null, null, null]);
    document.getElementById("verifyResult").textContent = '';
    document.getElementById('otp-input-0').focus();
  }



  return (
   
      <div className="Aa4">
        <div className="upside" >
          <div className="header">
            <div className="logo">
              {language === 'AR' ? ( <img fetchpriority='high' alt='' src='/kid-security-logo-ar.avif'/> ) : ( <img fetchpriority='high' alt='' src='/kid-security-logo-en.avif'/> )}
            </div>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className="title">
            <h1>{language === 'AR' ? 'امنح أطفالك الحرية الرقمية الآمنة: مع خدمة امان الاطفال، عالم رقمي مشرق لأطفالك' : 'Give your kids safe digital freedom: With Kid Security, a bright digital world for your kids'}</h1>
            <div className="photo">
              <img fetchpriority='high' alt='' src='/kid-security.avif'/> 
            </div>
          </div>
      </div>
      <div className="content">
        <div className="input">
          <p>{language === 'AR' ? 'املأ رقم هاتفك المحمول' : 'Fill Your Mobile Number'}</p>
          <div className={`textfield ${warning ? 'vibrate' : ''}`}>
            <div className="cc">+966</div>
            <input type='tel' value={msisdn} placeholder='05xxxxxxxx' autoComplete='off' minLength={9} maxLength={10} required onChange={handleMsisdnChange} />
          </div>
          <div className={`warning-msg ${warning ? 'active' : ''}`}>
            <span id="warning-msg">&nbsp;</span>
          </div>
          <button id="pin" onClick={handleSubscribeClick}>{language === 'AR' ? 'إشترك' : 'Subscribe'}</button>
          <span>{language === 'EN' ? '1 rial/day' : '١ ريال/يوم'}</span>
          <p id="sendResult" className="terms" style={{fontWeight:"bold"}}></p>
        </div>
        <div className="terms" style={{direction:"rtl"}}>
          {language === 'EN' ? <span>
              Kid Security is a subscription service available for STC users
              that costs 1 Riyal renewed daily for prepaid subscribers and
              costs 34.5 Riyals renewed monthly for postpaid subscribers
              (VAT Included) 
              To unsubscribe send U 1 to 802460, VAT Tax was already paid
              with a refill card for prepaid subscribers.<br></br>
              For Mobily Subscribers the service price is 1.15 Riyal daily with
              a 1-day free trial for the first subscription(VAT Included). 
              VAT Tax was already paid with a refill card for prepaid
              subscribers. and to unsubscribe send U 58 to 607110
            </span> : <span>
            امان الأطفال هي خدمة اشتراك متوفرة لعملاء شركة الاتصالات السعودية مقابل
             ١ ريال لعملاء مسبق الدفع تتجدد يومي وبمقابل ٣٤.٥ ريال لعملاء المفوتر تتجدد 
            شهري (شامل قيمة الضريبة المضافة) ولإلغاء الاشتراك الرجاء ارسال غ ١ الى
            802460 
            .تم تحصيل مبلغ الضريبة المضافة لعملاء مسبق الدفع عند عملية شحن الرصيد
            <br></br>لمشتركين موبايلي سعر الخدمة ١.٥١ ريال يوميا مع تجربة مجانية ليوم واحد عند
            اشتراكك اول مره (شامل قيمة الضريبة المضافة).
            تم تحصيل مبلغ الضريبة لعملاء مسبق الدفع عند عملية شحن الرصيد. ولإلغاء * *
            .الاشتراك أرسل غ ٥٨ إلى 607110
            </span>}
        </div>
        <div className='form-content-footer'>
            <Link to={`/aa4/terms?lang=${language}`}>{language === 'AR' ? (<a>أحكام وشروط</a>) : (<a>Terms and Condition</a>)}</Link>
            <svg fill="#fff" width="1em" height="1em" viewBox="-6.5 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M8.469-1.156h2.25v29.813h-2.25v-29.813z"></path></svg>
            {language === 'AR' ? (<a href='mailto:support@kid-security.io'>للتواصل انقر هنا</a>) : (<a href='mailto:support@kid-security.io'>Contact Us</a>)}
          </div>
      </div>

      <div className="popup" id="myOtp" ref={otpContainerRef}>
        <div className="popup-content">
          <span className="close" id="closeOtp" onClick={closeOtp}>&times;</span>
          <div className="otp-input-container">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="tel"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                className="otp-input"
                autoComplete="off"
              />
            ))}
          </div>
          <div className="verify">
            <button id="verify">{language === 'AR' ? 'التحقق من الرمز السري' : 'Verify PIN'}</button>
            <p id="verifyResult" className="terms" style={{fontWeight:"bold"}}></p>
          </div>
        </div>
      </div>

    </div>
    
  );
}

export default Aa4HomePage;